module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vfcthigh3-870e52352e6d4531b06341dfbf4bb313.jpg";